const getCtx = () => {
  if (!window.__ofisAudio) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) window.__ofisAudio = new AC();
  }
  return window.__ofisAudio;
};

export const SOUNDS = [
  { id: "none", name: "Kapalı" },
  { id: "ping", name: "Ping" },
  { id: "chime", name: "Çan" },
  { id: "beep", name: "Bip" },
  { id: "pop", name: "Pop" },
  { id: "blip", name: "Blip" },
  { id: "drop", name: "Damla" },
  { id: "knock", name: "Tık" },
  { id: "marimba", name: "Marimba" },
  { id: "alert", name: "Uyarı" },
  { id: "soft", name: "Yumuşak" },
];

const tone = (freq, start, dur, type = "sine", gain = 0.2) => {
  const c = getCtx();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + start;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur);
};

export function playSound(id) {
  try {
    const c = getCtx();
    if (!c || id === "none") return;
    if (c.state === "suspended") c.resume();
    switch (id) {
      case "ping": tone(880, 0, 0.3, "sine"); break;
      case "chime": tone(660, 0, 0.4); tone(990, 0.12, 0.5); break;
      case "beep": tone(700, 0, 0.15, "square", 0.15); tone(700, 0.2, 0.15, "square", 0.15); break;
      case "pop": tone(420, 0, 0.12, "triangle", 0.3); break;
      case "blip": tone(1200, 0, 0.08, "sine", 0.2); tone(1600, 0.09, 0.08, "sine", 0.2); break;
      case "drop": tone(600, 0, 0.3, "sine", 0.25); tone(300, 0.1, 0.3, "sine", 0.2); break;
      case "knock": tone(180, 0, 0.1, "square", 0.3); tone(150, 0.13, 0.1, "square", 0.3); break;
      case "marimba": tone(523, 0, 0.3, "triangle"); tone(659, 0.1, 0.3, "triangle"); tone(784, 0.2, 0.4, "triangle"); break;
      case "alert": tone(988, 0, 0.2, "sawtooth", 0.15); tone(740, 0.22, 0.3, "sawtooth", 0.15); break;
      case "soft": tone(523, 0, 0.5, "sine", 0.15); break;
      default: break;
    }
  } catch (e) { /* ignore */ }
}
